import React, { useEffect, useRef, useState } from "react";
import { Navbar, NavbarToggler } from "reactstrap";
import { useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import SideBar from "./SideBar";
import InitialsDDL from "./InitialsDDL";
import MPink from "../../src/assets/img/MPink.png";
import MainNavigation from "./MainNavigation";

const RestaurantHeader = () => {
  const history = useHistory();
  const location = useLocation();
  const { darkMode } = useSelector((state) => state.global);
  const { uid } = useSelector((state) => state.authUser);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const sidebarRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setSidebarOpen(false);
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleLanguageClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsActive(false);
      }
    };
    if (isActive) {
      window.addEventListener("click", handleLanguageClick);
    }
    return () => {
      window.removeEventListener("click", handleLanguageClick);
    };
  }, [isActive]);

  const excludedRoutes = ["/auth", "/main", "/register", "/forget-password", "/phone-auth"];
  const shouldShowNavbar = !excludedRoutes.includes(location.pathname);

  return (
    <div className={`${darkMode ? "Header-dark" : "Header"}`}>
      {shouldShowNavbar && (
        <>
          <Navbar
            className={`fixed-top d-flex justify-content-between align-items-center ${
              darkMode ? "bg-dark text-white" : "bg-white"
            } py-2`}
            style={{
              zIndex: 1000,
              backgroundColor: scrolled
                ? darkMode
                  ? "#ffffff"
                  : "#1a1a1a"
                : undefined,
              color: scrolled ? (darkMode ? "#000" : "#fff") : undefined,
              boxShadow: scrolled
                ? darkMode
                  ? "0 2px 6px rgba(255, 255, 255, 0.25)"
                  : "0 2px 6px rgba(0, 0, 0, 0.15)"
                : "none",
              transition: "all 0.3s ease-in-out",
            }}
          >
            {uid ? (
              <NavbarToggler onClick={toggleSidebar} className="me-2" />
            ) : (
              <MainNavigation title="" />
            )}
            <div>
              <img
                src={MPink}
                onClick={() => history.push("/restaurant")}
                className="img-fluid"
                alt="logo"
              />
            </div>
            <div className="me-auto d-flex cursor-pointer justify-content-center align-items-center mx-1 navbar__items">
              <InitialsDDL />
            </div>
          </Navbar>

          <div style={{ height: "70px" }} />
        </>
      )}

      <SideBar
        toggleSidebar={toggleSidebar}
        sidebarRef={sidebarRef}
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        isActive={isActive}
        setIsActive={setIsActive}
      />
    </div>
  );
};

export default RestaurantHeader;
